import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { createGuestUnsubscribeUsage, createGuestUnsubscribeSurveyUsage } from '../reducers/newLandingReducer'

class UnsubscribePage extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: 0,
      email: "",
      campaignId: ""
    }
    this.onValueChange = this.onValueChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
  }

  onValueChange(event) {
    this.setState({
      selectedOption: event.target.value
    });
  }

  formSubmit(event) {
    event.preventDefault();
    console.log(this.state.selectedOption)

    // send data back
    this.props.dispatch(createGuestUnsubscribeSurveyUsage(this.state.email, this.state.campaignId, this.state.selectedOption))
  }

  componentDidMount() {
  }

  render() {
    const { status } = this.props;

    // unsubscribe, for debug, use the commented link below
    // http://localhost:3006/cloak/exclude?email=marcus%40cloakapps.com&campaign_id=pil2021apr08
    var url = new URL(window.location.href)
    console.log("url " + url)
    this.state.email = url.searchParams.get("email")
    console.log("email " + this.state.email)
    this.state.campaignId = url.searchParams.get("campaign_id")
    console.log("campaignId " + this.state.campaignId)
    this.props.dispatch(createGuestUnsubscribeUsage(this.state.email, this.state.campaignId))


    return (
      <div className="clk-primary-qr-div">
        <div className="clk-primary-qr clk-box-shadow ">

          <div className="clk-signup-div">
            <div className="clk-main-title-div">
              <div className="clk-main-title-text">
                <FormattedMessage id="unsubscribe.title" />
              </div>
            </div>

            <div className="clk-main-title-div">
              <div className="clk-main-normal1-text">
                <FormattedMessage id="unsubscribe.message" />
              </div>
            </div>
            <br />

            <form onSubmit={this.formSubmit}>
              <div className="clk-main-title-div">
                <div className="clk-main-normal3-text">
                  <input
                    type="radio"
                    value="1a"
                    checked={this.state.selectedOption === "1a"}
                    onChange={this.onValueChange}
                  />
                  &nbsp;<FormattedMessage id="unsubscribe.option1" />
                </div>
              </div>
              <div className="clk-main-title-div">
                <div className="clk-main-normal3-text">
                  <input
                    type="radio"
                    value="1b"
                    checked={this.state.selectedOption === "1b"}
                    onChange={this.onValueChange}
                  />
                  &nbsp;<FormattedMessage id="unsubscribe.option2" />
                </div>
              </div>
              <div className="clk-main-title-div">
                <div className="clk-main-normal3-text">
                  <input
                    type="radio"
                    value="1c"
                    checked={this.state.selectedOption === "1c"}
                    onChange={this.onValueChange}
                  />
                  &nbsp;<FormattedMessage id="unsubscribe.option3" />
                </div>
              </div>
              <div className="clk-main-title-div">
                <div className="clk-main-normal3-text">
                  <input
                    type="radio"
                    value="1d"
                    checked={this.state.selectedOption === "1d"}
                    onChange={this.onValueChange}
                  />
                  &nbsp;<FormattedMessage id="unsubscribe.option4" />
                </div>
              </div>
              <div className="clk-primary-button-div">
                <button className="clk-primary-button" type="submit">
                  <FormattedMessage id="unsubscribe.submit" />
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  }
};

export default connect(mapStateToProps)(injectIntl(UnsubscribePage));
